import { Component, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-ajuda',
  templateUrl: './ajuda.component.html',
  styleUrls: ['./ajuda.component.scss'],
  imports: [MatExpansionModule],
})
export class AjudaComponent implements OnInit {
  panelOpenState: boolean;

  constructor() {}

  ngOnInit(): void {
    const panelOpenState = false;
  }
}
